import { useState } from 'preact/hooks';
import style from './style.css';
import TestimonialCard from './testimonialCard/index';
import { testimonialContent } from '../../../../constants';

const Testimonials = () => {
  const [showAllTestimonials, setShowAllTestimonials] = useState(false);
  const finalTestimonials = showAllTestimonials
    ? testimonialContent
    : testimonialContent.slice(0, 6);
  return (
    <div className={style.testimonialContainer}>
      <div className={style.innerContainer}>
        <div className={style.testimonialHeading}>
          What people say about our product
        </div>
        <div>
          <div>
            <div className={style.testimonialCardContainer}>
              {finalTestimonials.map((data) => {
                return (
                  <TestimonialCard
                    name={data.name}
                    desc={data.desc}
                    male={data.male}
                  />
                );
              })}
            </div>
          </div>
          <div className={style.moreTestimonialsContainer}>
            <div
              className={style.moreTestimonials}
              onClick={() => {
                setShowAllTestimonials(!showAllTestimonials);
              }}
            >
              See {showAllTestimonials ? 'Less' : 'More'} Testimonials
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;



// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVC/testimonials/index.js